<template>
    <div>
        <b-row>
            <b-col sm="7">
                <InputText title="Plano de Conta" field="name" :formName="formName" :required="true" :maxLength="40"
                    v-model="chartOfAccounts.name" :markFormDirty="false" :enter="create" />
            </b-col>
            <!-- <b-col sm="3">
                <div class="div-public">
                    <Toggle title="Pública" :color="'#26A69A'" v-model="chartOfAccounts.isPublic" />
                </div>
            </b-col> -->
            <b-col sm="2">
                <div class="text-left div-btn">
                    <Button _key="btnSaveChartOfAccounts" type="primary" :disabled="!isFormValid(formName)"
                        classIcon="fa-solid fa-plus" size="small" :clicked="create" />
                </div>
            </b-col>
        </b-row>
        <Alert type="info" v-if="chartOfAccounts.isPublic">
            <span>
                Ao marcar como Pública, outros módulos poderão acessar estas informações.
            </span>
        </Alert>
        <b-row>
            <b-col sm="12">
                <div class="list-card">
                    <ScrollBar :minHeight="400" :maxHeight="400">
                        <Loading type="line" :center="false" v-if="loading" />
                        <ul class="clean-list">
                            <li v-for="item in items" :key="item.id" class="item-row">
                                <div class="title" :title="item.name">
                                    <b-row>
                                        <b-col sm="1">
                                            <div class="item-icon" :style="'background:' + costCenter.color">
                                                <span :class="costCenter.icon"></span>
                                            </div>
                                        </b-col>
                                        <b-col sm="7">
                                            <InputTextEdit v-model="item.name" :params="item" :enter="update" />
                                        </b-col>
                                        <!-- <b-col sm="4">
                                            <Toggle title="Pública" :color="'#26A69A'" v-model="item.isPublic"
                                                :params="item" :changed="update" />
                                        </b-col> -->
                                    </b-row>
                                </div>
                                <div class="item-actions">
                                    <Button :_key="'btnRemove_' + item.id" type="danger" classIcon="fas fa-trash"
                                        size="small" :params="item" :clicked="remove" />
                                </div>
                            </li>

                            <li v-if="!items || items.length === 0" class="empty-state">
                                Nenhum registro encontrado.
                            </li>
                        </ul>
                    </ScrollBar>
                </div>
            </b-col>
        </b-row>
    </div>
</template>

<script>

import Alert from "@nixweb/nixloc-ui/src/component/layout/Alert";
import Button from "@nixweb/nixloc-ui/src/component/forms/Button";
import InputText from "@nixweb/nixloc-ui/src/component/forms/InputText";
import InputTextEdit from "@nixweb/nixloc-ui/src/component/forms/InputTextEdit.vue";
import RadioGroup from "@nixweb/nixloc-ui/src/component/forms/RadioGroup";
import Loading from "@nixweb/nixloc-ui/src/component/shared/Loading.vue";
import ScrollBar from "@nixweb/nixloc-ui/src/component/layout/ScrollBar";
import Toggle from "@nixweb/nixloc-ui/src/component/forms/Toggle";

import ChartOfAccounts from "@/components/modules/finance/chart-of-accounts/ChartOfAccounts.js";

import { mapGetters, mapActions, mapMutations } from "vuex";

export default {
    name: "ChartOfAccountsManage",
    props: {
        costCenter: Object,
    },
    components: { Alert, Button, InputText, InputTextEdit, RadioGroup, Loading, ScrollBar, Toggle },
    data() {
        return {
            formName: "chartOfAccountsCreateUpdateList",
            chartOfAccounts: new ChartOfAccounts(),
            urlCreate: "/api/v1/finance/chart-of-accounts/create",
            urlUpdate: "/api/v1/finance/chart-of-accounts/update",
            urlGetAll: "/api/v1/finance/chart-of-accounts/get-all",
            urlDelete: "/api/v1/finance/chart-of-accounts/delete",
            items: [],
            loading: false,
        };
    },
    computed: {
        ...mapGetters("validation", ["isFormValid"]),
        ...mapGetters("generic", ["event"]),
    },
    mounted() {
        if (this.chartOfAccounts.isPublic === undefined || this.chartOfAccounts.isPublic === null) {
            this.chartOfAccounts.isPublic = false;
        }
        this.getAll();
    },
    methods: {
        ...mapActions("generic", ["postApi", "putApi", "getApi", "deleteAllApi"]),
        ...mapMutations("generic", ["addEvent", "removeLoading", "hideModal", "hideVodal"]),
        ...mapMutations("validation", ["resetValidation"]),
        getAll() {
            this.loading = true;
            const ccId = this.costCenter && this.costCenter.id ? this.costCenter.id : null;
            this.getApi({ url: this.urlGetAll, obj: { any: ccId } }).then((response) => {
                if (response && response.success) this.items = response.content?.data || [];
                this.loading = false;
            });
        },
        create() {
            this.chartOfAccounts.costCenterId = this.costCenter.id;
            const params = { url: this.urlCreate, obj: this.chartOfAccounts };
            this.postApi(params).then((response) => {
                if (response && response.success) {
                    this.addEvent({ name: "chartOfAccountsSaved", data: this.chartOfAccounts });
                    this.removeLoading(["btnSaveChartOfAccounts"]);
                    this.afterSave();
                }
            });
        },
        update(param) {
            const params = {
                url: this.urlUpdate, obj: {
                    id: param.id,
                    name: param.name,
                    isPublic: param.isPublic,
                    costCenterId: this.costCenter.id,
                }
            };
            this.putApi(params).then((response) => {
                if (response && response.success) {
                    this.addEvent({ name: "chartOfAccountsSaved", data: this.chartOfAccounts });
                    this.afterSave();
                }
            });
        },
        remove(item) {
            const params = { url: this.urlDelete, selected: [item.id] };
            this.deleteAllApi(params).then((response) => {
                if (response.success) {
                    this.getAll();
                }
            });
        },
        afterSave() {
            this.getAll();
            const keepCostCenter = this.chartOfAccounts.costCenterId;
            this.resetValidation(this.formName);
            this.chartOfAccounts = new ChartOfAccounts();
            this.chartOfAccounts.costCenterId = keepCostCenter;
            this.chartOfAccounts.isPublic = false;
        },
    },
    watch: {
        event: {
            deep: true,
            handler(event) {
                if (event.name === "getAllChartOfAccounts") {
                    this.getAll();
                }
            },
        },
    },
};
</script>

<style scoped>
.list-card {
    border: 1px solid #eceff1;
    border-radius: 6px;
    background: #fff;
    overflow: hidden;
    box-shadow: 0 1px 2px rgba(16, 24, 40, .04);
}

.clean-list {
    list-style: none;
    padding: 0;
    margin: 0;
}

.item-row {
    display: grid;
    grid-template-columns: 1fr 140px auto;
    align-items: center;
    gap: .75rem;
    padding: .75rem 1rem;
    background: #fff;
    border-bottom: 1px solid #f1f3f5;
}

.item-row:last-child {
    border-bottom: none;
}

.item-name {
    min-width: 0;
    font-weight: 600;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.pill {
    display: inline-flex;
    align-items: center;
    border-radius: 999px;
    padding: .15rem .6rem;
    font-size: .85rem;
    font-weight: 600;
    border: 1px solid transparent;
}

.pill-yes {
    background: #e8f5e9;
    color: #2e7d32;
    border-color: #c8e6c9;
}


.item-actions {
    display: inline-flex;
    gap: .35rem;
    justify-content: flex-end;
}

.empty-state {
    padding: 1.25rem 1rem;
    text-align: center;
    color: #6b7280;
}

.item-icon {
    width: 28px;
    height: 28px;
    border-radius: 50px;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
}

.div-public {
    margin-top: 35px;
}

.div-btn {
    margin-top: 35px;
}
</style>
